module.exports = __webpack_public_path__ + "static/media/line_following_robots.1a348a5e.webp";